const OutboundPhoneMode = Object.freeze({
  none: "none",
  group_default: "group_default",
  outbound_phone_code: "outbound_phone_code",
});

export default OutboundPhoneMode;
